// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"48":"18fa33f9","460":"e1b20ef3","637":"35a2f5f9","751":"18fa33f9"}[chunkId] + ".css";
};